export default __webpack_public_path__ + "static/media/order_3.43254512.png";